export const CONFIRMED_GET_UNIT_DOSES = "CONFIRMED_GET_UNIT_DOSES";
export const CONFIRMED_CREATE_UNIT_DOSE = "CONFIRMED_CREATE_UNIT_DOSE";
export const CONFIRMED_DELETE_UNIT_DOSE = "CONFIRMED_DELETE_UNIT_DOSE";
export const CONFIRMED_EDIT_UNIT_DOSE = "CONFIRMED_EDIT_UNIT_DOSE";
